import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import Modal from './modal';

export interface SheetDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: React.ReactNode;
  title?: React.ReactNode;
  body?: React.ReactNode;
  noTrigger?: boolean;
  fullScreen?: boolean;
  hideHeader?: boolean;
  noSpacing?: boolean;
  /** نام شیت در آدرس */
  name?: string;
}

/**
 * پیاده‌سازی مشترک دیالوگ/مودال‌های Plasmic (`Dialog`, `Paziresh24Dialog`, `Paziresh24Modal`)
 * روی همان `Modal` سراسری (باتم‌شیت + Back مرورگر + مسیر در آدرس). API همان API Plasmic است
 * تا کدهای تولیدشده بدون تغییر کار کنند.
 */
export function SheetDialog({ open, onOpenChange, trigger, title, body, noTrigger, fullScreen, hideHeader, noSpacing, name = 'dialog' }: SheetDialogProps) {
  const [innerOpen, setInnerOpen] = React.useState(false);
  const isOpen = open ?? innerOpen;
  // Lazy until first opened: a search page mounts ~80 closed dialogs (docs/performance.md §۳.۸).
  const [activated, setActivated] = React.useState(isOpen);
  if (isOpen && !activated) setActivated(true);
  const setOpen = (next: boolean) => {
    if (open === undefined) setInnerOpen(next);
    onOpenChange?.(next);
  };
  const hasTrigger = !noTrigger && trigger != null && trigger !== false;
  const showHeader = !hideHeader && title != null && title !== false;

  return (
    <>
      {hasTrigger &&
        (React.isValidElement(trigger) && trigger.type !== React.Fragment ? (
          <Slot
            aria-haspopup="dialog"
            aria-expanded={isOpen}
            data-state={isOpen ? 'open' : 'closed'}
            onClick={(event: React.MouseEvent) => {
              if (!event.defaultPrevented) setOpen(true);
            }}
          >
            {trigger}
          </Slot>
        ) : (
          <div onClick={() => setOpen(true)}>{trigger}</div>
        ))}
      {activated && (
        <Modal
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          title={title}
          noHeader={!showHeader}
          fullScreen={fullScreen}
          bodyClassName={noSpacing ? '!p-0' : undefined}
          name={name}
        >
          {body}
        </Modal>
      )}
    </>
  );
}

export default SheetDialog;
